import { render, staticRenderFns } from "./Lheader.vue?vue&type=template&id=506c2d6e&scoped=true"
import script from "./Lheader.vue?vue&type=script&lang=js"
export * from "./Lheader.vue?vue&type=script&lang=js"
import style0 from "./Lheader.vue?vue&type=style&index=0&id=506c2d6e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506c2d6e",
  null
  
)

export default component.exports